import { useState } from "react";
import { Divider, Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import Drawer from "ui-components/Drawer";
import { getESOLog } from "services/data.outbound.service";
import { soStatusLabel } from "layouts/views/common/enum";
import MDTypography from "components/MDTypography";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Quantity", id: "quantity" },
  { label: "Base UOM", id: "baseUOM" },
  { label: "Cancel Quantity", id: "cancelQuantity" },
  { label: "Cancel Date", id: "cancelDate" },
  // { label: "Status", id: "status" },
];

function ESOLog({ open1, setOpen1, logRequest, setLogRequest }) {
  //const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["so-log", { logRequest }],
    queryFn: () => getESOLog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      console.log(data.data.data);
      const item = data.data.data;

      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
        <TimelineItem key={id} {...log} />
      ));
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Cust Order Num : </b>
                {item.custOrdNbr}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>

              <Grid item xs={6}>
                <b>Cust Name : </b>
                {item.custName}
              </Grid>
              <Grid item xs={6}>
                <b>Sales Rep Name : </b>
                {item.salesRepName}
              </Grid>

              <Grid item xs={6}>
                <b>Ship Address : </b>
                {item.shipAddress}
              </Grid>
              <Grid item xs={6}>
              </Grid>

              <Grid item xs={6}>
                <b>Shipment Type : </b>
                {item.shipmentType}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable
              columns={columns}
              rows={item.details.map((x) => ({ ...x }))}
              //rows={item.details.map((x) => ({ ...x, status: soStatusLabel[x.status] }))}
            />
          </div>
          <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
        </>
      );
      //setLogRequest({ coNumber: "", custCode: "" });
    },
    //onError,
  });

  const toggleDrawer = (open1) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen1(open1);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <Drawer width="1400px" open={open1} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <MDTypography variant="h5" color="info">
        E Sales Order
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {logs}
    </Drawer>
  );
}

export default ESOLog;
